module.exports = __webpack_public_path__ + "static/media/out-of-stock-supplies-blue.c73b1a69.svg";